import * as React from "react";
import type { SVGProps } from "react";
const SvgWhatsapp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#whatsapp_svg__a)">
      <path d="M12.01 22c-1.39 0-2.79-.29-4.09-.88l-4.74.84c-.36.07-.73-.08-.96-.36a.99.99 0 0 1-.13-1.02l1.43-3.3a9.9 9.9 0 0 1-1.37-6.99 9.95 9.95 0 0 1 4.1-6.47C10.76.64 17.01 1.73 20.18 6.24S22.27 17 17.76 20.17A10 10 0 0 1 12 22zm-3.96-2.92c.15 0 .3.03.44.1a7.98 7.98 0 0 0 8.12-.64C20.22 16 21.08 11 18.54 7.39a7.97 7.97 0 0 0-5.17-3.28c-2.11-.37-4.23.11-5.97 1.34a7.97 7.97 0 0 0-3.28 5.17c-.37 2.1.11 4.23 1.34 5.97.2.29.24.65.1.97l-.91 2.09 3.21-.57c.06-.01.12-.02.18-.02z" />
      <path d="M15 15.98h-1c-3.31 0-6-2.69-6-6v-1c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v1c0 .57-.31 1.06-.78 1.31.4 1.15 1.31 2.06 2.46 2.46.25-.46.75-.78 1.31-.78h1c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z" />
    </g>
    <defs>
      <clipPath id="whatsapp_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWhatsapp;
